import { Button, Modal, Table } from "semantic-ui-react";
import { CRMService } from "../../../app/stores/CRMStore/service";
import { useEffect, useState } from "react";
import { useStore } from "../../../app/stores/store";
import { observer } from "mobx-react-lite";

interface HistoryItem {
  id: number;
  dateTime: string;
  status: string;
  username: string;
}

const HistoryModel = () => {
  const { CRMStore } = useStore()
  const { assetTracking:{isHistory,selectedId} } = CRMStore;
  const [data, setData] = useState<{ historyData: HistoryItem[] }>({ historyData: [] });

  useEffect(()=>{
    apiCall();
    //eslint-disable-next-line
  },[])
  const apiCall = async () => {
    try {
      const response = await CRMService.assetModifyHistory(selectedId);
      setData({ historyData: response.data }); // Ensure the response matches the expected structure
    } catch (error) {
      console.log(error);
    }
  };

  const headers = data.historyData.length > 0 ? Object.keys(data.historyData[0]) : [];

  return (
    <Modal open={isHistory} dimmer={'dimmer'}>
      <Modal.Header>History Details</Modal.Header>
      <Modal.Content style={{height:'70vh'}}>
        <Table celled>
          <Table.Header>
            <Table.Row>
              {headers.map((header) => (
                <Table.HeaderCell key={header}>{header.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())}</Table.HeaderCell>
              ))}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data.historyData.map((item) => (
              <Table.Row key={item.id}>
                {headers.map((header) => (
                  <Table.Cell key={header}>{(item as any)[header]}</Table.Cell>
                ))}
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Modal.Content>
      <Modal.Actions>
        <Button color="red" onClick={() => {
          CRMStore.assetTracking.isHistory = false
          CRMStore.assetTracking.selectedId = ''}}>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default observer(HistoryModel)